import React, { useMemo } from 'react';
import { Table as AntDesignTable } from 'antd';
import { useSelector } from 'react-redux';
import * as S from './Table.styled';

/**
 * Wrapper do Ant Design Table (v4) com suporte a <caption> (AccessMonitor table_02 / H39).
 * Em antd 4 não há prop nativa `caption`; injetamos via `components.table`.
 */
function Table({ caption, components, ...props }) {
  const theme = useSelector(state => state.configuration);

  const mergedComponents = useMemo(() => {
    if (!caption) {
      return components;
    }

    const UserTable = components?.table;

    return {
      ...components,
      table: tableProps => {
        const { children, ...tableRest } = tableProps;
        const body = (
          <>
            <caption>{caption}</caption>
            {children}
          </>
        );

        if (typeof UserTable === 'function') {
          return <UserTable {...tableRest}>{body}</UserTable>;
        }

        return <table {...tableRest}>{body}</table>;
      },
    };
  }, [caption, components]);

  return (
    <S.TableResize theme={theme}>
      <S.Table theme={theme} components={mergedComponents} {...props} />
    </S.TableResize>
  );
}

// Compatibilidade com API do AntD: permite usar <Table.Column />, etc.
Table.Column = AntDesignTable.Column;
Table.ColumnGroup = AntDesignTable.ColumnGroup;
Table.Summary = AntDesignTable.Summary;

export default Table;
